const DIVIDER_TYPE = "wix-draft-plugin-divider";
export {
  DIVIDER_TYPE
};
//# sourceMappingURL=types.js.map
